import { IconChevronDown } from 'assets/icons';
import { useIsMobile } from 'hooks/common';
import React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import styled from 'styled-components';

const GotoTopButton = styled.div<{ $screenWidth: number; $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  padding: 10px;

  border: 1px solid;
  border-color: rgba(234, 235, 236, 1);

  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(65, 75, 86, 1);

  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);

  cursor: pointer;
  pointer-events: auto;

  ${({ $isMobile, $screenWidth }) =>
    `
    width: ${$isMobile ? '44px' : '59px'};
    height: ${$isMobile ? '44px' : '64px'};
    border-radius: ${$isMobile ? '50%' : '12px'};
  `}
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  transform: rotate(180deg);
`;

const TriangleIcon = styled.div`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid rgba(65, 75, 86, 1);

  border-radius: 2px;
`;

interface Props {
  handleGotoTop: () => void;
}

function GoTopButton({ handleGotoTop }: Props) {
  const isMobile = useIsMobile();
  const { width } = useResizeDetector();

  // const handleGotoTop = () => {
  //   document.body.scrollTo({
  //     top: 0,
  //     behavior: 'smooth',
  //   });
  // };

  return (
    <GotoTopButton
      onClick={handleGotoTop}
      $isMobile={isMobile}
      $screenWidth={width}
    >
      {isMobile ? (
        <IconContainer>
          <IconChevronDown width={24} height={24} />
        </IconContainer>
      ) : (
        <TriangleIcon />
      )}

      {isMobile ? <></> : '맨위로'}
    </GotoTopButton>
  );
}

export default GoTopButton;
